import React from "react";
import styles from "./BackgroundHTML.module.css";

function BackgroundNode() {
  return (
    <div className={styles.backgroundNode}>
      <pre>
        <span className={styles.component}>const </span>
        <span className={styles.class}>express = require</span>
        <span className={styles.white}>(</span>
        <span className={styles.classValue}>"express"</span>
        <span className={styles.white}>);</span>
        <br />
        <span className={styles.component}>const </span>
        <span className={styles.class}>app = express</span>
        <span className={styles.white}>(</span>
        <span className={styles.white}>);</span>
        <br />
        <span className={styles.component}>app</span>
        <span className={styles.class}>.set</span>
        <span className={styles.white}>(</span>
        <span className={styles.classValue}>"view engine"</span>
        <span className={styles.white}>,</span>
        <span className={styles.classValue}> "ejs"</span>
        <span className={styles.white}>);</span>
        <br />
        <span className={styles.component}>app</span>
        <span className={styles.class}>.use</span>
        <span className={styles.white}>(</span>
        <span className={styles.class}>express.static</span>
        <span className={styles.white}>(</span>
        <span className={styles.component}>__dirname </span>
        <span className={styles.white}>+</span>
        <span className={styles.classValue}> "/views"</span>
        <span className={styles.white}>));</span>
        <br />
        <span className={styles.component}>app</span>
        <span className={styles.class}>.get</span>
        <span className={styles.white}>(</span>
        <span className={styles.classValue}> "/"</span>
        <span className={styles.white}>, </span>
        <span className={styles.component}>async </span>
        <span className={styles.white}>(</span>
        <span className={styles.component}>req</span>
        <span className={styles.white}>, </span>
        <span className={styles.component}>res</span>
        <span className={styles.white}>)</span>
        <span className={styles.component}> =&gt; </span>
        <span className={styles.white}>&#123;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.component}>const </span>
        <span className={styles.class}>shortUrls = </span>
        <span className={styles.white}>await </span>
        <span className={styles.component}>ShortURL</span>
        <span className={styles.class}>.find</span>
        <span className={styles.white}>();</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.component}>res</span>
        <span className={styles.class}>.render</span>
        <span className={styles.white}>(</span>
        <span className={styles.classValue}> "index"</span>
        <span className={styles.white}>, &#123; </span>
        <span className={styles.component}>ShortURL :</span>
        <span className={styles.class}> shortUrls </span>
        <span className={styles.white}>&#125;);</span>
        <br />
        <span className={styles.white}>&#125;);</span>
        <br />
        <span className={styles.component}>app</span>
        <span className={styles.class}>.listen</span>
        <span className={styles.white}>(</span>
        <span className={styles.class}>process.env</span>
        <span className={styles.component}>.port</span>
        <span className={styles.white}> &#124;&#124; </span>
        <span className={styles.class}>5000</span>
        <span className={styles.white}>);</span>
      </pre>
    </div>
  );
}

export default BackgroundNode;
